export default "__VITE_ASSET__X3B7$S0e__"